<ng-container *ngIf="isReadOnly; else showInputNumber">
  <div class="p-text-bold-500" *ngIf="this.useGrouping">
    {{
      this.bindingFormControl?.value
        | number : useDecimalSetting
        | replaceNullWith : '-'
    }}
  </div>
  <div class="p-text-bold-500" *ngIf="!this.useGrouping">
    {{ this.bindingFormControl?.value | replaceNullWith : '-' }}
  </div>
</ng-container>
<ng-template #showInputNumber>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <p-inputNumber
      *ngIf="render"
      sigvInputNumberSetting
      [step]="step"
      [round]="round"
      [maxlength]="maxNumberlength"
      [minFractionDigits]="minFractionDigits ?? 0"
      [maxFractionDigits]="maxFractionDigits ?? 0"
      [numberOnly]="numberOnly"
      [inputStyle]="isInputRight ? { 'text-align': 'right' } : {}"
      [allowNegative]="allowNegative"
      [style]="maxlength ? { width: useWidth } : {}"
      placeholder=" {{
        (placeholder == undefined ? 'Please Enter' : placeholder) | translate
      }}"
      [formControl]="bindingFormControl"
      (onBlur)="blurEvent($event)"
      [min]="min"
      [max]="max"
      [useGrouping]="useGrouping"
      inputId="{{ inputId }}"
    >
    </p-inputNumber>
  </sigv-form-control-widget>
</ng-template>
